import React, { type ComponentProps, type ReactNode } from 'react'

import type { BannerProps } from '@fourthwall/components'
import {
  Banner,
  BaseContent,
  Button,
  Icon,
  Skeleton,
  useMediaQueryContext,
} from '@fourthwall/components'
import { ExclamationMarkIcon } from '@fourthwall/icons'

import * as S from './GoogleAnalytics.styled'
import GoogleAnalyticsImage from './assets/google-analytics.svg'

type GoogleAnalyticsBarViewProps = {
  title: string
  description: ReactNode
  banner?: BannerProps
  issue?: string
  button?: ComponentProps<typeof Button>
}

export const GoogleAnalyticsView = ({
  title,
  description,
  banner,
  issue,
  button,
}: GoogleAnalyticsBarViewProps) => (
  <S.Container>
    <S.Content>
      <div>
        <img src={GoogleAnalyticsImage} alt="Google Analytics logo" />
      </div>
      <div style={{ display: 'grid', gap: 1 }}>
        <BaseContent>
          <strong>{title}</strong>
        </BaseContent>
        <BaseContent appearance="secondary" size="small">
          {description}
        </BaseContent>
      </div>
      {button && <Button {...button} />}
      {issue && (
        <S.Issue>
          <Icon component={ExclamationMarkIcon} height={16} />
          {issue}
        </S.Issue>
      )}
    </S.Content>
    {banner && <Banner {...banner} />}
  </S.Container>
)

const GoogleAnalyticsBarViewSkeleton = () => {
  const media = useMediaQueryContext()

  return (
    <Skeleton>
      <Skeleton.Shape width="100%" height={media.tablet ? 84 : 243} />
    </Skeleton>
  )
}

GoogleAnalyticsView.Skeleton = GoogleAnalyticsBarViewSkeleton
